<script setup lang="ts">
import TasksTable from '@/modules/tasks/components/TasksTable.vue'
</script>

<template>
  <TasksTable />
</template>
